module.exports = __webpack_public_path__ + "img/hospital.26502b7e.jpeg";